export default __webpack_public_path__ + "static/media/calculator.135eedb7.svg";